import { HttpParams } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { LazyLoadEvent } from 'primeng/primeng';

import { BaseCrudService } from '../../shared/_utils/services/base-crud-service';
import { QueryOperator } from '../../shared/_utils/services/query-operator.enum';
import { IncomeNature } from '../entities/incomeNature';
import { ResponsePageable } from '../../shared/_utils/services/responsePageable';

@Injectable()
export class IncomeNatureService extends BaseCrudService<IncomeNature> {

  public uri = '/api/incomeNature/';

  constructor(injector: Injector) {
    super(injector);
   //console.log('Instance IncomeNatureService');
  }

  buildSentence(entity?: IncomeNature, event?: LazyLoadEvent): HttpParams {
    if (entity) {
      let query = entity.code ? 'code'
        + QueryOperator.Contain + entity.code
        + QueryOperator.Split : QueryOperator.Empty;
      query = query.concat(
        entity.name ? 'name'
          + QueryOperator.Contain + entity.name
          + QueryOperator.Split : QueryOperator.Empty
      );
      if (entity.fiscalYear) {
        query = query.concat(
            entity.fiscalYear.id ? 'fiscalYear.id' + QueryOperator.Equal
            + entity.fiscalYear.id + QueryOperator.Split : QueryOperator.Empty
        );
      }
      this.httpParams = this.httpParams.set(QueryOperator.QueryParam, query);
    }

    if (event) {
      const page = ((event.first + event.rows) / event.rows - 1).toString();
      const size = event.rows.toString();
      this.httpParams = this.httpParams.set(QueryOperator.PageParam, page);
      this.httpParams = this.httpParams.set(QueryOperator.SizeParam, size);
    }
    return this.httpParams;
  }

  // getSequenceCode(): Observable<string> {
  //   const url = this.rutaServidor + this.uri + 'maxCode/';
  //   return this.httpClient.get<any>(url)
  //     .pipe(
  //       map(response => {
  //         // debugger;
  //         const code = response.maxCode ? response.maxCode : FormatUtils.padLeftZero(0, 10);
  //         const sequence = (parseInt(code, 10)) + 1;
  //         return FormatUtils.padLeftZero(sequence, 10);
  //       }),
  //       tap(response => {
  //        //console.log(response);
  //       })
  //     );
  // }
}



// WEBPACK FOOTER //
// ./src/app/core/services/income-nature.service.ts